import { propertyType, t } from '@blocksuite/data-view';
import zod from 'zod';

import {
  ROLLUP_PROPERTY_TYPE,
  RollupPropertySchema,
  RollupRawValueSchema,
} from './types.js';

export const rollupPropertyType = propertyType(ROLLUP_PROPERTY_TYPE);

export const rollupPropertyModelConfig = rollupPropertyType.modelConfig({
  name: 'Rollup',
  propertyData: {
    schema: RollupPropertySchema,
    default: () =>
      ({
        _v: 1,
        sourceRelationPropertyId: null,
        targetPropertyId: null,
        aggregationType: null,
      }) as const,
  },
  jsonValue: {
    schema: zod.unknown(),
    isEmpty: ({ value }) => value == null,
    type: () => t.unknown.instance(),
  },
  rawValue: {
    schema: RollupRawValueSchema,
    default: () => null,
    toString: () => '',
    fromString: () => ({ value: null }),
    toJson: () => null,
    fromJson: () => null,
  },
});
